<template>
  <div class="flex -mx-3">
    <div class="flex-1 px-3 space-y-4">
      <RouterLink :to="url">
        {{ facebookCampaign.name }}
      </RouterLink>
      <span class="block mt-1 text-sm text-muted">{{ facebookCampaign.id }}</span>
      <div class="rounded p-2 bg-gray-200">
        <ul class="flex items-stretch -mx-2 text-center">
          <li class="flex flex-col flex-1 px-2 space-y-4">
            <div class="flex-1 text-xs text-gray-600">
              {{ $t('impressions') | capitalize }}
            </div>
            <div>
              {{ impressions | thousands }}
            </div>
          </li>
          <li class="flex flex-col flex-1 px-2 space-y-4">
            <div class="flex-1 text-xs text-gray-600">
              {{ $t('reach') | capitalize }}
            </div>
            <div>
              {{ reach | thousands }}
            </div>
          </li>
          <li class="flex flex-col flex-1 px-2 space-y-4">
            <div class="flex-1 text-xs text-gray-600">
              {{ $t('visits') | capitalize }}
            </div>
            <div>
              {{ inlineLinkClicks | thousands }}
            </div>
          </li>
          <li class="flex flex-col flex-1 px-2 space-y-4">
            <div class="flex-1 text-xs text-gray-600">
              {{ $t('costPerClick') | capitalize }}
            </div>
            <div>{{ costPerClick }}&euro;</div>
          </li>
          <li class="flex flex-col flex-1 px-2 space-y-4">
            <div class="flex-1 text-xs text-gray-600">
              {{ $t('conversions') | capitalize }}
            </div>
            <div>{{ conversions }}&#37;</div>
          </li>
          <li class="flex flex-col flex-1 px-2 space-y-8">
            <div class="flex-1 text-xs text-gray-600">
              {{ $t('spend') | capitalize }}
            </div>
            <div>{{ spend }}&euro;</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="w-48 px-3">
      {{ facebookCampaign.objective }}
    </div>
    <div class="w-32 px-3">
      {{ facebookCampaign.status }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratItem',
  props: {
    facebookCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    url() {
      return {
        name: 'admin.facebookCampaigns.show',
        params: {
          facebookCampaignId: this.facebookCampaign.id,
        },
      };
    },
    impressions() {
      return this.facebookCampaign?.lifetimeReport?.impressions || 0;
    },
    reach() {
      return this.facebookCampaign?.lifetimeReport?.reach || 0;
    },
    inlineLinkClicks() {
      return this.facebookCampaign?.lifetimeReport?.inlineLinkClicks || 0;
    },
    spend() {
      return this.facebookCampaign?.lifetimeReport?.spend || 0;
    },
    costPerClick() {
      if (!this.spend) return 0;
      if (!this.inlineLinkClicks) return this.spend;
      return (this.spend / this.inlineLinkClicks).toFixed(2);
    },
    conversions() {
      if (!this.inlineLinkClicks) return 0;
      return (this.inlineLinkClicks / this.reach).toFixed(2);
    },
  },
};
</script>
